import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams } from "react-router-dom";
import CryptoJS from "crypto-js";
import './App.css';

function App() {
  const [searchParams] = useSearchParams();
  const containerRef = useRef(null);

  useEffect(() => {
    try {
      const token = searchParams.get("token");
      const encryptedUrlFromQuery = decodeURIComponent(token);

      const decryptedBytes = CryptoJS.AES.decrypt(encryptedUrlFromQuery, "NDRhYzRmNjMtYWQzMC00");
      const decryptedHtml = decryptedBytes.toString(CryptoJS.enc.Utf8);
      console.log(decryptedHtml)
      if (containerRef.current) {
        containerRef.current.innerHTML = decryptedHtml;
        const form = containerRef.current.querySelector("#form-auto-submit");

        if (form) {
          form.submit();
        }
      }
    }
    catch (err) {
      console.log(err)
    }
  }, [])

  return (
    <div className="App">
      <header className="App-header">
        <p>
          Please wait, redirecting to secure payment site.
        </p>
        <div ref={containerRef} />
      </header>
    </div>
  );
}

export default App;
